import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import { Location } from '@angular/common';
import { Route, Router } from '@angular/router';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { BtnCellRendererEdit } from 'src/app/common/button-cell-renderer-editable-component';
import Swal from 'sweetalert2';
import { InputFieldRenderer } from 'src/app/common/input-field-renderer-component';
import { InputCheckBoxFieldRenderer } from 'src/app/common/input-checkbox-field-renderer.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TransactionMasterService } from './transaction-master-service';
import { CountryMasterService } from '../country-master-rule/country-master-service';
import { InputFieldWithoutDecimalRenderer } from 'src/app/common/input-field-without-decimal';


@Component({
  selector: 'app-transaction-master-rule',
  templateUrl: './transaction-master-rule.component.html',
  styleUrls: ['./transaction-master-rule.component.scss']
})
export class TransactionMasterRuleComponent implements OnInit {

  @ViewChild('emailConfiguration') private emailConfigurationModal: ModalComponent;
  emailConfig : ModalConfig;
  
  userTypeList : any[];
  userType : any;
  selectedAgent : any;
  agentList : any[];
  public permissions : any;
  aml18Data : any[];
  aml19Data : any[];
  labelList : any[];
  labelListAml18 : any[];
  labelListAml19 : any[];
  aml18Dropdown : any[];
  aml19Dropdown : any[];
  emailListAgent : any[];
  emailListCustomer : any[];
  maxCountSize : Number = 4;
  maxAmountSize : Number = 7;
  private gridApi18: GridApi;
  private gridApi19: GridApi;
  private gridApiEmail : GridApi;
  addEmailForm !: FormGroup;
  submitted : boolean = false;

    //Form Group for AML
    AML001 !: FormGroup;
    submittedAML001 : boolean = false;

    AML002 !: FormGroup;
    submittedAML002 : boolean = false;

    AML003 !: FormGroup;
    submittedAML003 : boolean = false;

    // AML004 !: FormGroup;
    // submittedAML004 : boolean = false;

    AML005Amount !: FormGroup;
    submittedAML005Amount : boolean = false;

    AML005Count !: FormGroup;
    submittedAML005Count : boolean = false;

    AML006Amount !: FormGroup;
    submittedAML006Amount : boolean = false;

    AML006Count !: FormGroup;
    submittedAML006Count : boolean = false;

    AML007 !: FormGroup;
    submittedAML007 : boolean = false;

    AML008 !: FormGroup;
    submittedAML008 : boolean = false;

    // AML009 !: FormGroup;
    // submittedAML009 : boolean = false;

    AML010 !: FormGroup;
    submittedAML010 : boolean = false;

    AML013 !: FormGroup;
    submittedAML013 : boolean = false;

    AML015 !: FormGroup;
    submittedAML015 : boolean = false;

    AML018 !: FormGroup;
    submittedAML018 : boolean = false;


    AML019 !: FormGroup;
    submittedAML019 : boolean = false;

    AML021Sender !: FormGroup;
    submittedAML021Sender : boolean = false;

    AML021Receiver !: FormGroup;
    submittedAML021Receiver : boolean = false;

    AML023 !: FormGroup;
    submittedAML023 : boolean = false;

    AML026Sender !: FormGroup;
    submittedAML026Sender : boolean = false;

    AML026Receiver !: FormGroup;
    submittedAML026Receiver : boolean = false;

    AML027 !: FormGroup;
    submittedAML027 : boolean = false;

  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };

  public columnDefAml18: ColDef[] = [
    {field: 'label',lockVisible:true,  headerName: 'Label',},
    {field: 'enable',lockVisible:true,  headerName: 'Enable', cellRenderer : InputCheckBoxFieldRenderer},
    {field: 'notify',lockVisible:true,  headerName: 'Notify', cellRenderer : InputCheckBoxFieldRenderer},
    {field: 'block',lockVisible:true,  headerName: 'Block', cellRenderer : InputCheckBoxFieldRenderer},
    {field: 'dailyCount',lockVisible:true,  headerName: 'Daily Count',cellRenderer:  InputFieldWithoutDecimalRenderer,  cellRendererParams : {
      maxLength: this.maxCountSize
    },onCellValueChanged: (params: any) => {
      console.log(params.newValue);
      console.log(params.data.weeklyCount);
        if(params.data.weeklyCount == "" || params.data.weeklyCount == undefined){
          console.log(params.data.weeklyCount);
          return;
        }
        if (Number(params.newValue) > Number(params.data.weeklyCount)) {
          console.log("Not Valid");
          const rowNode = this.gridApi18.getRowNode((params.node.rowIndex).toString());
            if (rowNode) {
              let temp = "";
              this.alertService.toastWarringMessageAlertWithMessage("Daily Count cannot be greater than Weekly Count");
              rowNode.setDataValue('dailyCount',0);
            } 
        }
    }},
    {field: 'id', headerName: 'ID', hide: true },
    {field: 'weeklyCount',lockVisible:true,  headerName: 'Weekly Count',cellRenderer:  InputFieldWithoutDecimalRenderer,cellRendererParams : {
      maxLength: this.maxCountSize
    },onCellValueChanged: (params: any) => {
      console.log(params.newValue);
      console.log(params.data.monthlyCount);
        if(params.data.monthlyCount == "" || params.data.monthlyCount == undefined){
          console.log(params.data.monthlyCount);
          return;
        }
        if (Number(params.newValue) > Number(params.data.monthlyCount)) {
          console.log("Not Valid");
          const rowNode = this.gridApi18.getRowNode((params.node.rowIndex).toString());
            if (rowNode) {
              let temp = "";
              this.alertService.toastWarringMessageAlertWithMessage("Weekly Count cannot be greater than Monthly Count");
              rowNode.setDataValue('weeklyCount',Number(params.data.dailyCount)+1);
            } 
        }
    }},
    {field: 'monthlyCount',lockVisible:true,  headerName: 'Monthly Count',cellRenderer:  InputFieldWithoutDecimalRenderer,cellRendererParams : {maxLength: this.maxCountSize}},
    {field: 'dailyAmount',lockVisible:true,  headerName: 'Daily Amount', cellRendererParams : {
      maxLength: this.maxAmountSize
    },cellRenderer:  InputFieldWithoutDecimalRenderer,onCellValueChanged: (params: any) => {
      console.log(params.newValue);
      console.log(params.data.weeklyAmount);
        if(params.data.weeklyAmount == "" || params.data.weeklyAmount == undefined){
          return;
        }
        if (Number(params.newValue) > Number(params.data.weeklyAmount)) {
          console.log("Not Valid");
          const rowNode = this.gridApi18.getRowNode((params.node.rowIndex).toString());
            if (rowNode) {
              let temp = "";
              this.alertService.toastWarringMessageAlertWithMessage("Daily Amount cannot be greater than Weekly Amount");
              rowNode.setDataValue('dailyAmount',1);
            } 
        }
    }},
    {field: 'weeklyAmount',lockVisible:true,  headerName: 'Weekly Amount' ,cellRenderer:  InputFieldWithoutDecimalRenderer,cellRendererParams : {
      maxLength: this.maxAmountSize
    },onCellValueChanged: (params: any) => {
      console.log(params.newValue);
      console.log(params.data.monthlyAmount);
        if(params.data.monthlyAmount == "" || params.data.monthlyAmount == undefined){
          return;
        }
        if (Number(params.newValue) > Number(params.data.monthlyAmount)) {
          console.log("Not Valid");
          const rowNode = this.gridApi18.getRowNode((params.node.rowIndex).toString());
            if (rowNode) {
              let temp = "";
              this.alertService.toastWarringMessageAlertWithMessage("Weekly Amount cannot be greater than Monthly Amount");
              rowNode.setDataValue('weeklyAmount',Number(params.data.dailyAmount)+1);
            } 
        }
    }},
    {field: 'monthlyAmount',lockVisible:true,  headerName: 'Monthly Amount',cellRenderer:  InputFieldWithoutDecimalRenderer,cellRendererParams : {maxLength: this.maxAmountSize}},
    {
      field: 'actions', headerName: 'Actions', width: 280, cellRenderer: BtnCellRendererEdit, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            console.log(param.data);
            console.log(param.data.editFlag);
            if(param.data.editFlag){
              let check:boolean =await this.updateAml18(param.data);
              if(check){
                param.data.editFlag = !param.data.editFlag 
                console.log(param.data.editFlag);
              }
            }else{
              param.data.editFlag = !param.data.editFlag 
              console.log(param.data.editFlag);
            }
            
          },
          buttonEditClass: 'icon-save',
          buttonSaveClass: 'icon-edit',
          buttonVisible: true
        },
        {
          clicked: async (event: any, param: any) => {
            console.log(param.data);
            console.log(param);
            this.deleteAmlRule('aml018',param.data.label);
          },
          buttonEditClass: 'icon-delete',
          buttonSaveClass: 'icon-delete',
          buttonVisible: false
        }
      ]
    }
  ];

  public columnDefAml19: ColDef[] = [
    {field: 'label',lockVisible:true,  headerName: 'Label',},
    {field: 'enable',lockVisible:true,  headerName: 'Enable', cellRenderer : InputCheckBoxFieldRenderer},
    {field: 'notify',lockVisible:true,  headerName: 'Notify', cellRenderer : InputCheckBoxFieldRenderer},
    {field: 'block',lockVisible:true,  headerName: 'Block', cellRenderer : InputCheckBoxFieldRenderer},
    {field: 'dailyCount',lockVisible:true,  headerName: 'Daily Count',cellRenderer:  InputFieldWithoutDecimalRenderer,  cellRendererParams : {
      maxLength: this.maxCountSize
    },onCellValueChanged: (params: any) => {
      console.log(params.newValue);
      console.log(params.data.weeklyCount);
        if(params.data.weeklyCount == "" || params.data.weeklyCount == undefined){
          console.log(params.data.weeklyCount);
          return;
        }
        if (Number(params.newValue) > Number(params.data.weeklyCount)) {
          console.log("Not Valid");
          const rowNode = this.gridApi19.getRowNode((params.node.rowIndex).toString());
            if (rowNode) {
              let temp = "";
              this.alertService.toastWarringMessageAlertWithMessage("Daily Count cannot be greater than Weekly Count");
              rowNode.setDataValue('dailyCount',0);
            } 
        }
    }},
    {field: 'id', headerName: 'ID', hide: true },
    {field: 'weeklyCount',lockVisible:true,  headerName: 'Weekly Count',cellRenderer:  InputFieldWithoutDecimalRenderer,cellRendererParams : {
      maxLength: this.maxCountSize
    },onCellValueChanged: (params: any) => {
      console.log(params.newValue);
      console.log(params.data.monthlyCount);
        if(params.data.monthlyCount == "" || params.data.monthlyCount == undefined){
          console.log(params.data.monthlyCount);
          return;
        }
        if (Number(params.newValue) > Number(params.data.monthlyCount)) {
          console.log("Not Valid");
          const rowNode = this.gridApi19.getRowNode((params.node.rowIndex).toString());
            if (rowNode) {
              let temp = "";
              this.alertService.toastWarringMessageAlertWithMessage("Weekly Count cannot be greater than Monthly Count");
              rowNode.setDataValue('weeklyCount',Number(params.data.dailyCount)+1);
            } 
        }
    }},
    {field: 'monthlyCount',lockVisible:true,  headerName: 'Monthly Count',cellRenderer:  InputFieldWithoutDecimalRenderer,cellRendererParams : {maxLength: this.maxCountSize}},
    {field: 'dailyAmount',lockVisible:true,  headerName: 'Daily Amount', cellRendererParams : {
      maxLength: this.maxAmountSize
    },cellRenderer:  InputFieldWithoutDecimalRenderer,onCellValueChanged: (params: any) => {
      console.log(params.newValue);
      console.log(params.data.weeklyAmount);
        if(params.data.weeklyAmount == "" || params.data.weeklyAmount == undefined){
          return;
        }
        if (Number(params.newValue) > Number(params.data.weeklyAmount)) {
          console.log("Not Valid");
          const rowNode = this.gridApi19.getRowNode((params.node.rowIndex).toString());
            if (rowNode) {
              let temp = "";
              this.alertService.toastWarringMessageAlertWithMessage("Daily Amount cannot be greater than Weekly Amount");
              rowNode.setDataValue('dailyAmount',1);
            } 
        }
    }},
    {field: 'weeklyAmount',lockVisible:true,  headerName: 'Weekly Amount' ,cellRenderer:  InputFieldWithoutDecimalRenderer,cellRendererParams : {
      maxLength: this.maxAmountSize
    },onCellValueChanged: (params: any) => {
      console.log(params.newValue);
      console.log(params.data.monthlyAmount);
        if(params.data.monthlyAmount == "" || params.data.monthlyAmount == undefined){
          return;
        }
        if (Number(params.newValue) > Number(params.data.monthlyAmount)) {
          console.log("Not Valid");
          const rowNode = this.gridApi19.getRowNode((params.node.rowIndex).toString());
            if (rowNode) {
              let temp = "";
              this.alertService.toastWarringMessageAlertWithMessage("Weekly Amount cannot be greater than Monthly Amount");
              rowNode.setDataValue('weeklyAmount',Number(params.data.dailyAmount)+1);
            } 
        }
    }},
    {field: 'monthlyAmount',lockVisible:true,  headerName: 'Monthly Amount',cellRenderer:  InputFieldWithoutDecimalRenderer,cellRendererParams : {maxLength: this.maxAmountSize}},
    {
      field: 'actions', headerName: 'Actions', width: 280, cellRenderer: BtnCellRendererEdit, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            console.log(param.data);
            console.log(param.data.editFlag);
            if(param.data.editFlag){
              let check:boolean = await this.updateAml19(param.data);
              if(check){
                param.data.editFlag = !param.data.editFlag 
                console.log(param.data.editFlag);
              }
            }else{
              param.data.editFlag = !param.data.editFlag 
              console.log(param.data.editFlag);
            }
            
          },
          buttonEditClass: 'icon-save',
          buttonSaveClass: 'icon-edit',
          buttonVisible: true
        },
        {
          clicked: async (event: any, param: any) => {
            console.log(param.data);
            console.log(param);
            this.deleteAmlRule('aml019',param.data.label);
          },
          buttonEditClass: 'icon-delete',
          buttonSaveClass: 'icon-delete',
          buttonVisible: false
        }
      ]
    }
  ];

  public columnDefEmailConfig: ColDef[] = [
    {field: 'email',lockVisible:true, width:800, headerName: 'Email ID',},
    {field: 'id', headerName: 'ID', hide: true },
    {field: 'actions',lockVisible:true, headerName: 'Actions', width: 305,cellRenderer: BtnCellRenderer, cellRendererParams: [
      {
        clicked: async (event: any, param: any) => {
          console.log(param);
          this.deleteEmail(param.data.userType,param.data.id);
        },
        buttonIconClass: 'icon-delete'
      },
    ]
  }
  ];

  tableSelectedColumn18: ColDef[] = [...(this.columnDefAml18.filter((col) => !col?.hide))];
  tableSelectedColumn19: ColDef[] = [...(this.columnDefAml19.filter((col) => !col?.hide))];
  tableSelectedColumnEmail: ColDef[] = [...(this.columnDefEmailConfig.filter((col) => !col?.hide))];
  constructor(private location : Location,private menuService : MenusService,private alertService : AlertService,private router : Router,private formBuilder : FormBuilder,private transactionService : TransactionMasterService, private changeDetectorRef : ChangeDetectorRef,private countryService : CountryMasterService) { }

  ngOnInit(): void {
    this.emailListAgent = [];
    this.emailListCustomer = [];
    // this.emailListAgent = [{"email":"developer@pay10.ae"},{"email":"testing@pay10.ae"},{"email":"compliance@pay10.ae"}]
    // this.emailListCustomer = [{"email":"developer@pay10.ae"},{"email":"testing@pay10.ae"},{"email":"compliance@pay10.ae"}]
    this.aml18Data = [];
    // this.aml18Data = [{"label":"A","enable":true,"notify":true,"block":false,"dailyCount":10,"weeklyCount":50,"monthlyCount":100,"dailyAmount":1000,"weeklyAmount":2000,"monthlyAmount":4000},{"label":"B","enable":false,"notify":false,"block":true,"dailyCount":5,"weeklyCount":10,"monthlyCount":29,"dailyAmount":500,"weeklyAmount":800,"monthlyAmount":1200}];
    this.aml19Data = [];
    // this.aml19Data = [{"label":"A","enable":true,"notify":true,"block":false,"dailyCount":10,"weeklyCount":50,"monthlyCount":100,"dailyAmount":1000,"weeklyAmount":2000,"monthlyAmount":4000},{"label":"B","enable":false,"notify":false,"block":true,"dailyCount":5,"weeklyCount":10,"monthlyCount":29,"dailyAmount":500,"weeklyAmount":800,"monthlyAmount":1200}];
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      this.router.navigateByUrl('/');
    }

    this.emailConfig = {
      modalTitle: "Email Configuration",
      modalSize: 'xl',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.userType = [];
    this.labelListAml18 = [];
    this.labelListAml19 = [];
    this.userTypeList = [{"name":"Customer","value":"DEFAULT_CUSTOMER"},{"name":"Agent","value":"AGENT"}]
    this.agentList = [{"name":"Default","value":"DEFAULT_AGENT"},{"name":"Agent 1","value":"AGENT1"},{"name":"Agent 2","value":"AGENT2"}]
    // this.labelList = [{"name":"Label 1","flag":true, "class":"card border-light cards text-bg-secondary"},{"name":"Label 2","flag":false, "class":"card border-light cards text-bg-secondary"},{"name":"Label 3","flag":true, "class":"card border-light cards text-bg-secondary"},{"name":"Label 4","flag":true, "class":"card border-light cards text-bg-secondary"},{"name":"Label 1","flag":true, "class":"card border-light cards text-bg-secondary"},{"name":"Label 2","flag":false, "class":"card border-light cards text-bg-secondary"},{"name":"Label 3","flag":true, "class":"card border-light cards text-bg-secondary"},{"name":"Label 4","flag":true, "class":"card border-light cards text-bg-secondary"}];

    this.formGroupSetup();
  }

  formGroupSetup(){

    this.addEmailForm = this.formBuilder.group({
      emailInput : ['',[Validators.required,Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@pay10.ae$')]],
    })

    this.AML001 = this.formBuilder.group({
      notify : [''],
      block : [''],
      dailyCount : ['',Validators.required],
      weeklyCount : ['',Validators.required],
      monthlyCount : ['',Validators.required],
    })

    this.AML002 = this.formBuilder.group({
      notify : [''],
      block : [''],
      dailyCount : ['',Validators.required],
      weeklyCount : ['',Validators.required],
      monthlyCount : ['',Validators.required],
    })

    this.AML003 = this.formBuilder.group({
      notify : [''],
      block : [''],
      dailyCount : ['',Validators.required],
      weeklyCount : ['',Validators.required],
      monthlyCount : ['',Validators.required],
      dailyThresholdPercentage : ['',Validators.required],
      weeklyThresholdPercentage : ['',Validators.required],
      monthlyThresholdPercentage : ['',Validators.required],
    })

    // this.AML004 = this.formBuilder.group({
    //   notify : [''],
    //   block : [''],
    //   dailyCount : ['',Validators.required],
    //   weeklyCount : ['',Validators.required],
    //   monthlyCount : ['',Validators.required],
    //   dailyThresholdPercentage : ['',Validators.required],
    //   weeklyThresholdPercentage : ['',Validators.required],
    //   monthlyThresholdPercentage : ['',Validators.required],
    // })

    this.AML005Amount = this.formBuilder.group({
      notify : [''],
      block : [''],
      dailyAmount : ['',Validators.required],
      weeklyAmount : ['',Validators.required],
      monthlyAmount : ['',Validators.required],
    })

    this.AML005Count = this.formBuilder.group({
      notify : [''],
      block : [''],
      dailyCount : ['',Validators.required],
      weeklyCount : ['',Validators.required],
      monthlyCount : ['',Validators.required],
    })

    this.AML006Amount = this.formBuilder.group({
      notify : [''],
      block : [''],
      dailyAmount : ['',Validators.required],
      weeklyAmount : ['',Validators.required],
      monthlyAmount : ['',Validators.required],
    })

    this.AML006Count = this.formBuilder.group({
      notify : [''],
      block : [''],
      dailyCount : ['',Validators.required],
      weeklyCount : ['',Validators.required],
      monthlyCount : ['',Validators.required],
    })

    this.AML007 = this.formBuilder.group({
      notify : [''],
      block : [''],
      thresholdPercentage : ['',Validators.required],
      months : [null,Validators.required],
    })

    this.AML008 = this.formBuilder.group({
      notify : [''],
      block : [''],
      flipCount : ['',Validators.required],
      configurableMonth : ['',Validators.required],
    })

    // this.AML009 = this.formBuilder.group({
    //   notify : [''],
    //   block : [''],
    //   flipCount : ['',Validators.required],
    //   configurableMonth : ['',Validators.required],
    // })

    this.AML010 = this.formBuilder.group({
      notify : [''],
      block : [''],
      thresholdAmount : ['',Validators.required],
      minutes : ['',Validators.required],
      thresholdPercentage : ['',Validators.required],
    })

    this.AML013 = this.formBuilder.group({
      notify : [''],
      block : [''],
      dailyAmount : ['',Validators.required],
      weeklyAmount : ['',Validators.required],
      monthlyAmount : ['',Validators.required],
      dailyCount : ['',Validators.required],
      weeklyCount : ['',Validators.required],
      monthlyCount : ['',Validators.required],
    })

    this.AML015 = this.formBuilder.group({
      notify : [''],
      block : [''],
      countries : ['',Validators.required],
      dailyAmount : ['',Validators.required],
      weeklyAmount : ['',Validators.required],
      monthlyAmount : ['',Validators.required],
      dailyCount : ['',Validators.required],
      weeklyCount : ['',Validators.required],
      monthlyCount : ['',Validators.required],
    })

    //List
    this.AML018 = this.formBuilder.group({
      notify : [''],
      block : [''],
      dailyAmount : ['',Validators.required],
      weeklyAmount : ['',Validators.required],
      monthlyAmount : ['',Validators.required],
      dailyCount : ['',Validators.required],
      weeklyCount : ['',Validators.required],
      monthlyCount : ['',Validators.required],
    })

    //List
    this.AML019 = this.formBuilder.group({
      notify : [''],
      block : [''],
      dailyAmount : ['',Validators.required],
      weeklyAmount : ['',Validators.required],
      monthlyAmount : ['',Validators.required],
      dailyCount : ['',Validators.required],
      weeklyCount : ['',Validators.required],
      monthlyCount : ['',Validators.required],
    })

    this.AML021Sender = this.formBuilder.group({
      notify : [''],
      block : [''],
      dailyAmount : ['',Validators.required],
      weeklyAmount : ['',Validators.required],
      monthlyAmount : ['',Validators.required],
      dailyCount : ['',Validators.required],
      weeklyCount : ['',Validators.required],
      monthlyCount : ['',Validators.required],
    })

    this.AML021Receiver = this.formBuilder.group({
      notify : [''],
      block : [''],
      dailyAmount : ['',Validators.required],
      weeklyAmount : ['',Validators.required],
      monthlyAmount : ['',Validators.required],
      dailyCount : ['',Validators.required],
      weeklyCount : ['',Validators.required],
      monthlyCount : ['',Validators.required],
    })

    this.AML023 = this.formBuilder.group({
      notify : [''],
      block : [''],
      dailyAmount : ['',Validators.required],
      weeklyAmount : ['',Validators.required],
      monthlyAmount : ['',Validators.required],
      dailyCount : ['',Validators.required],
      weeklyCount : ['',Validators.required],
      monthlyCount : ['',Validators.required],
    })

    this.AML026Sender = this.formBuilder.group({
      notify : [''],
      block : [''],
      dailyAmount : ['',Validators.required],
      weeklyAmount : ['',Validators.required],
      monthlyAmount : ['',Validators.required],
      dailyCount : ['',Validators.required],
      weeklyCount : ['',Validators.required],
      monthlyCount : ['',Validators.required],
    })

    this.AML026Receiver = this.formBuilder.group({
      notify : [''],
      block : [''],
      dailyAmount : ['',Validators.required],
      weeklyAmount : ['',Validators.required],
      monthlyAmount : ['',Validators.required],
      dailyCount : ['',Validators.required],
      weeklyCount : ['',Validators.required],
      monthlyCount : ['',Validators.required],
    })

    this.AML027 = this.formBuilder.group({
      notify : [''],
      block : [''],
      dailyAmount : ['',Validators.required],
      weeklyAmount : ['',Validators.required],
      monthlyAmount : ['',Validators.required],
      dailyCount : ['',Validators.required],
      weeklyCount : ['',Validators.required],
      monthlyCount : ['',Validators.required],
    })
  }

  onGridReady(params: GridReadyEvent<any>) {
    this.gridApi18 = params.api
    this.gridApi19 = params.api
    this.gridApiEmail = params.api
  }

  userTypeChange(userType:any){
    this.resetAllForm();
    console.log(userType);
    if(userType == "DEFAULT_CUSTOMER"){
      this.countryService.getLabelList().subscribe((response:any)=>{
        console.log(response);
        this.labelList = response.response.data;
        console.log(this.labelList);
        this.labelListAml18 = this.labelList.slice(0);
        this.labelListAml19 = this.labelList.slice(0);
      })
      this.transactionService.getAMLRule(userType).subscribe((response:any)=>{
        console.log(response.response.data);
        if(response.response.status == 200){
          this.setAmlValues("set",response.response.data);
        }
      })
    }
  }

  agentChange(agent:any){
    this.resetAllForm();
    console.log(agent);
    if(agent != undefined){
      this.countryService.getLabelList().subscribe((response:any)=>{
        console.log(response);
        this.labelList = response.response.data;
        console.log(this.labelList);
        this.labelListAml18 = this.labelList.slice(0);
        this.labelListAml19 = this.labelList.slice(0);
      });
      this.transactionService.getAMLRule(agent).subscribe((response:any)=>{
        console.log(response.response.data);
        if(response.response.data == null){
          this.transactionService.getAMLRule("DEFAULT_AGENT").subscribe((res:any)=>{
            console.log(res.response.data)
            if(res.response.status == 200){
              this.setAmlValues("set",res.response.data);
            }
          })
        }else{
          if(response.response.status == 200){
            this.setAmlValues("set",response.response.data);
          }
        }
      })
    }
  }

  setAmlValues(operation :String,data:any){
    this.AML001.setValue({
      notify : data.aml001.notify,
      block : data.aml001.block,
      dailyCount: data.aml001.dailyCount,
      weeklyCount: data.aml001.weeklyCount,
      monthlyCount: data.aml001.monthlyCount
    });

    this.AML002.setValue({
      notify : data.aml002.notify,
      block : data.aml002.block,
      dailyCount: data.aml002.dailyCount,
      weeklyCount: data.aml002.weeklyCount,
      monthlyCount: data.aml002.monthlyCount
    });

    this.AML003.setValue({
      notify : data.aml003.notify,
      block : data.aml003.block,
      dailyCount: data.aml003.dailyCount,
      weeklyCount: data.aml003.weeklyCount,
      monthlyCount: data.aml003.monthlyCount,
      dailyThresholdPercentage : data.aml003.dailyThresholdPercentage,
      weeklyThresholdPercentage : data.aml003.weeklyThresholdPercentage,
      monthlyThresholdPercentage : data.aml003.monthlyThresholdPercentage,
    });

    // this.AML004.setValue({
    //   notify : data.aml004.notify,
    //   block : data.aml004.block,
    //   dailyCount: data.aml004.dailyCount,
    //   weeklyCount: data.aml004.weeklyCount,
    //   monthlyCount: data.aml004.monthlyCount,
    //   dailyThresholdPercentage : data.aml004.dailyThresholdPercentage,
    //   weeklyThresholdPercentage : data.aml004.weeklyThresholdPercentage,
    //   monthlyThresholdPercentage : data.aml004.monthlyThresholdPercentage,
    // });

    this.AML005Amount.setValue({
      notify : data.aml005Amount.notify,
      block : data.aml005Amount.block,
      dailyAmount: data.aml005Amount.dailyAmount,
      weeklyAmount: data.aml005Amount.weeklyAmount,
      monthlyAmount: data.aml005Amount.monthlyAmount
    });

    this.AML005Count.setValue({
      notify : data.aml005Count.notify,
      block : data.aml005Count.block,
      dailyCount: data.aml005Count.dailyCount,
      weeklyCount: data.aml005Count.weeklyCount,
      monthlyCount: data.aml005Count.monthlyCount
    });

    this.AML006Amount.setValue({
      notify : data.aml006Amount.notify,
      block : data.aml006Amount.block,
      dailyAmount: data.aml006Amount.dailyAmount,
      weeklyAmount: data.aml006Amount.weeklyAmount,
      monthlyAmount: data.aml006Amount.monthlyAmount
    });

    this.AML006Count.setValue({
      notify : data.aml006Count.notify,
      block : data.aml006Count.block,
      dailyCount: data.aml006Count.dailyCount,
      weeklyCount: data.aml006Count.weeklyCount,
      monthlyCount: data.aml006Count.monthlyCount
    });

    this.AML007.setValue({
      notify : data.aml007.notify,
      block : data.aml007.block,
      thresholdPercentage: data.aml007.thresholdPercentage,
      months: data.aml007.months
    });

    this.AML008.setValue({
      notify : data.aml008.notify,
      block : data.aml008.block,
      flipCount: data.aml008.flipCount,
      configurableMonth: data.aml008.configurableMonth,
    });

    // this.AML009.setValue({
    //   notify : data.aml009.notify,
    //   block : data.aml009.block,
    //   flipCount: data.aml009.flipCount,
    //   configurableMonth: data.aml009.configurableMonth,
    // });

    this.AML010.setValue({
      notify : data.aml010.notify,
      block : data.aml010.block,
      thresholdAmount: data.aml010.thresholdAmount,
      thresholdPercentage: data.aml010.thresholdPercentage,
      minutes: data.aml010.minutes
    });

    this.AML013.setValue({
      notify : data.aml013.notify,
      block : data.aml013.block,
      dailyAmount: data.aml013.dailyAmount,
      weeklyAmount: data.aml013.weeklyAmount,
      monthlyAmount: data.aml013.monthlyAmount,
      dailyCount: data.aml013.dailyCount,
      weeklyCount: data.aml013.weeklyCount,
      monthlyCount: data.aml013.monthlyCount
    });

    this.AML015.setValue({
      notify : data.aml015.notify,
      block : data.aml015.block,
      countries: data.aml015.countries,
      dailyAmount: data.aml015.dailyAmount,
      weeklyAmount: data.aml015.weeklyAmount,
      monthlyAmount: data.aml015.monthlyAmount,
      dailyCount: data.aml015.dailyCount,
      weeklyCount: data.aml015.weeklyCount,
      monthlyCount: data.aml015.monthlyCount
    });

    this.aml18Data = data.aml018.amlTableItems;
    if(operation != "delete"){
      for( var i=this.labelListAml18.length - 1; i>=0; i--){
        for( var j=0; j<this.aml18Data.length; j++){
            if(this.labelListAml18[i] && (this.labelListAml18[i].label === this.aml18Data[j].label)){
              this.labelListAml18.splice(i, 1);
            }
        }
      }
    }else if(operation == "delete"){
      this.labelListAml18 = [];
      this.labelListAml18 = this.labelList.slice(0);
      for( var i=this.labelListAml18.length - 1; i>=0; i--){
        for( var j=0; j<this.aml18Data.length; j++){
            if(this.labelListAml18[i] && (this.labelListAml18[i].label === this.aml18Data[j].label)){
              this.labelListAml18.splice(i, 1);
            }
        }
      }
    }
    console.log(this.labelListAml18);


    this.aml19Data = data.aml019.amlTableItems;
    if(operation != "delete"){
      for( var i=this.labelListAml19.length - 1; i>=0; i--){
        for( var j=0; j<this.aml19Data.length; j++){
            if(this.labelListAml19[i] && (this.labelListAml19[i].label === this.aml19Data[j].label)){
              this.labelListAml19.splice(i, 1);
            }
        }
      }
    }else if(operation == "delete"){
      this.labelListAml19 = [];
      this.labelListAml19 = this.labelList.slice(0);
      for( var i=this.labelListAml19.length - 1; i>=0; i--){
        for( var j=0; j<this.aml19Data.length; j++){
            if(this.labelListAml19[i] && (this.labelListAml19[i].label === this.aml19Data[j].label)){
              this.labelListAml19.splice(i, 1);
            }
        }
      }
    }
    console.log(this.labelListAml19);
    

    this.AML021Sender.setValue({
      notify : data.aml021Sender.notify,
      block : data.aml021Sender.block,
      dailyAmount: data.aml021Sender.dailyAmount,
      weeklyAmount: data.aml021Sender.weeklyAmount,
      monthlyAmount: data.aml021Sender.monthlyAmount,
      dailyCount: data.aml021Sender.dailyCount,
      weeklyCount: data.aml021Sender.weeklyCount,
      monthlyCount: data.aml021Sender.monthlyCount
    });

    this.AML021Receiver.setValue({
      notify : data.aml021Receiver.notify,
      block : data.aml021Receiver.block,
      dailyAmount: data.aml021Receiver.dailyAmount,
      weeklyAmount: data.aml021Receiver.weeklyAmount,
      monthlyAmount: data.aml021Receiver.monthlyAmount,
      dailyCount: data.aml021Receiver.dailyCount,
      weeklyCount: data.aml021Receiver.weeklyCount,
      monthlyCount: data.aml021Receiver.monthlyCount
    });

    this.AML023.setValue({
      notify : data.aml023.notify,
      block : data.aml023.block,
      dailyAmount: data.aml023.dailyAmount,
      weeklyAmount: data.aml023.weeklyAmount,
      monthlyAmount: data.aml023.monthlyAmount,
      dailyCount: data.aml023.dailyCount,
      weeklyCount: data.aml023.weeklyCount,
      monthlyCount: data.aml023.monthlyCount
    });

    this.AML026Sender.setValue({
      notify : data.aml026Sender.notify,
      block : data.aml026Sender.block,
      dailyAmount: data.aml026Sender.dailyAmount,
      weeklyAmount: data.aml026Sender.weeklyAmount,
      monthlyAmount: data.aml026Sender.monthlyAmount,
      dailyCount: data.aml026Sender.dailyCount,
      weeklyCount: data.aml026Sender.weeklyCount,
      monthlyCount: data.aml026Sender.monthlyCount
    });

    this.AML026Receiver.setValue({
      notify : data.aml026Receiver.notify,
      block : data.aml026Receiver.block,
      dailyAmount: data.aml026Receiver.dailyAmount,
      weeklyAmount: data.aml026Receiver.weeklyAmount,
      monthlyAmount: data.aml026Receiver.monthlyAmount,
      dailyCount: data.aml026Receiver.dailyCount,
      weeklyCount: data.aml026Receiver.weeklyCount,
      monthlyCount: data.aml026Receiver.monthlyCount
    });

    this.AML027.setValue({
      notify : data.aml027.notify,
      block : data.aml027.block,
      dailyAmount: data.aml027.dailyAmount,
      weeklyAmount: data.aml027.weeklyAmount,
      monthlyAmount: data.aml027.monthlyAmount,
      dailyCount: data.aml027.dailyCount,
      weeklyCount: data.aml027.weeklyCount,
      monthlyCount: data.aml027.monthlyCount
    });
  }

  resetAllForm(){
    this.AML001.reset();
    this.AML002.reset();
    this.AML003.reset();
    // this.AML004.reset();
    this.AML005Amount.reset();
    this.AML005Count.reset();
    this.AML006Amount.reset();
    this.AML006Count.reset();
    this.AML007.reset();
    this.AML008.reset();
    // this.AML009.reset();
    this.AML010.reset();
    this.AML013.reset();
    this.AML015.reset();
    this.AML018.reset();
    this.labelList = [];
    this.aml18Data = [];
    this.labelListAml18 = [];
    this.aml19Data = [];
    this.labelListAml19 = [];
    this.AML019.reset();
    this.AML021Sender.reset();
    this.AML021Receiver.reset();
    this.AML023.reset();
    this.AML026Sender.reset();
    this.AML026Receiver.reset();
  }

  addAML001Rule(ruleType :any, ruleData : any){
    console.log(this.userType);
    console.log(ruleType);
    console.log(ruleData);
    this.submittedAML001 = true;
    if(this.AML001.valid){
      console.log("Valid");
      if(ruleData.dailyCount){
        console.log("validate daily count");
        if(Number(ruleData.dailyCount) > Number(ruleData.weeklyCount)){
          this.alertService.errorAlertWithMessage("Daily Count cannot be greater than Weekly Count");
          return;
        }
      }

      if(ruleData.weeklyCount){
        console.log("validate weekly count");
        if(Number(ruleData.weeklyCount) > Number(ruleData.monthlyCount)){
          this.alertService.errorAlertWithMessage("Weekly Count cannot be greater than Monthly Count");
          return;
        }
      }
      let id = this.userType;
      if(this.userType=="AGENT"){
        id = this.selectedAgent;
      }
      console.log(id);
      var formData = {
        "id" : id,
        [ruleType] : ruleData
      }
      console.log(formData);
      this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('AML001 Rule updated successfully','','success');
        }else{
          Swal.fire(' Error while updating the rule','','error');
        }
      })
    }else{
      console.log("Not Valid");
    }
    
  }

  addAML002Rule(ruleType :any, ruleData : any){
    console.log(this.userType);
    console.log(ruleType);
    console.log(ruleData);
    this.submittedAML002 = true;
    if(this.AML002.valid){
      console.log("Valid");
      if(ruleData.dailyCount){
        console.log("validate daily count");
        if(Number(ruleData.dailyCount) > Number(ruleData.weeklyCount)){
          this.alertService.errorAlertWithMessage("Daily Count cannot be greater than Weekly Count");
          return;
        }
      }

      if(ruleData.weeklyCount){
        console.log("validate weekly count");
        if(Number(ruleData.weeklyCount) > Number(ruleData.monthlyCount)){
          this.alertService.errorAlertWithMessage("Weekly Count cannot be greater than Monthly Count");
          return;
        }
      }
      let id = this.userType
      if(this.userType=="AGENT"){
        id = this.selectedAgent;
      }
      console.log(id);
      var formData = {
        "id" : id,
        [ruleType] : ruleData
      }
      console.log(formData);
      this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('AML002 Rule updated successfully','','success');
        }else{
          Swal.fire(' Error while updating the rule','','error');
        }
      })
    }else{
      console.log("Not Valid");
    }
    
  }

  addAML003Rule(ruleType :any, ruleData : any){
    console.log(this.userType);
    console.log(ruleType);
    console.log(ruleData);
    this.submittedAML003 = true;
    if(this.AML003.valid){
      console.log("Valid");
      if(ruleData.dailyCount){
        if(Number(ruleData.dailyCount) > Number(ruleData.weeklyCount)){
          this.alertService.errorAlertWithMessage("Daily Count cannot be greater than Weekly Count");
          return;
        }
      }

      if(ruleData.weeklyCount){
        if(Number(ruleData.weeklyCount) > Number(ruleData.monthlyCount)){
          this.alertService.errorAlertWithMessage("Weekly Count cannot be greater than Monthly Count");
          return;
        }
      }

      if(ruleData.dailyThresholdPercentage){
        if(Number(ruleData.dailyThresholdPercentage) > 100){
          this.alertService.errorAlertWithMessage("Daily Percentage cannot be greater than 100 Percentage");
          return;
        }
      }

      if(ruleData.weeklyThresholdPercentage){
        if(Number(ruleData.weeklyThresholdPercentage) > 100){
          this.alertService.errorAlertWithMessage("Weekly Percentage cannot be greater than 100 Percentage");
          return;
        }
      }

      if(ruleData.monthlyThresholdPercentage){
          if(Number(ruleData.monthlyThresholdPercentage) > 100){
            this.alertService.errorAlertWithMessage("Monthly Percentage cannot be greater than 100 Percentage");
            return;
          }
      }
      let id = this.userType;
      if(this.userType=="AGENT"){
        id = this.selectedAgent;
      }
      console.log(id);
      var formData = {
        "id" : id,
        [ruleType] : ruleData
      }
      console.log(formData);
      this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('AML003 Rule updated successfully','','success');
        }else{
          Swal.fire(' Error while updating the rule','','error');
        }
      })
    }else{
      console.log("Not Valid");
    }
  }

  // addAML004Rule(ruleType :any, ruleData : any){
  //   console.log(this.userType);
  //   console.log(ruleType);
  //   console.log(ruleData);
  //   this.submittedAML004 = true;
  //   if(this.AML004.valid){
  //     console.log("Valid");
  //     if(ruleData.dailyCount){
  //       if(Number(ruleData.dailyCount) > Number(ruleData.weeklyCount)){
  //         this.alertService.errorAlertWithMessage("Daily Count cannot be greater than Weekly Count");
  //         return;
  //       }
  //     }

  //     if(ruleData.weeklyCount){
  //       if(Number(ruleData.weeklyCount) > Number(ruleData.monthlyCount)){
  //         this.alertService.errorAlertWithMessage("Weekly Count cannot be greater than Monthly Count");
  //         return;
  //       }
  //     }

  //     if(ruleData.dailyPercentage){
  //       if(Number(ruleData.dailyPercentage) > Number(ruleData.weeklyPercentage)){
  //         this.alertService.errorAlertWithMessage("Daily Percentage cannot be greater than Weekly Percentage");
  //         return;
  //       }
  //     }

  //     if(ruleData.weeklyPercentage){
  //       if(Number(ruleData.weeklyPercentage) > Number(ruleData.monthlyPercentage)){
  //         this.alertService.errorAlertWithMessage("Weekly Percentage cannot be greater than Monthly Percentage");
  //         return;
  //       }
  //     }
  //     let id = this.userType;
  //     if(this.userType=="AGENT"){
  //       id = this.selectedAgent;
  //     }
  //     console.log(id);
  //     var formData = {
  //       "id" : id,
  //       [ruleType] : ruleData
  //     }
  //     console.log(formData);
  //     this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
  //       console.log(response);
  //       if(response.response.status == 200){
  //         Swal.fire('AML004 Rule updated successfully','','success');
  //       }else{
  //         Swal.fire(' Error while updating the rule','','error');
  //       }
  //     })
  //   }else{
  //     console.log("Not Valid");
  //   }
  // }

  addAML005SenderRule(ruleType :any, ruleData : any){
    console.log(this.userType);
    console.log(ruleType);
    console.log(ruleData);
    this.submittedAML005Amount = true;
    if(this.AML005Amount.valid){
      console.log("Valid");
      if(ruleData.dailyAmount){
        if(Number(ruleData.dailyAmount) > Number(ruleData.weeklyAmount)){
          this.alertService.errorAlertWithMessage("Daily Amount cannot be greater than Weekly Amount");
          return;
        }
      }

      if(ruleData.weeklyAmount){
        if(Number(ruleData.weeklyAmount) > Number(ruleData.monthlyAmount)){
          this.alertService.errorAlertWithMessage("Weekly Amount cannot be greater than Monthly Amount");
          return;
        }
      }
      let id = this.userType;
      if(this.userType=="AGENT"){
        id = this.selectedAgent;
      }
      console.log(id);
      var formData = {
        "id" : id,
        [ruleType] : ruleData
      }
      console.log(formData);
      this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('AML005.1 Rule updated successfully','','success');
        }else{
          Swal.fire(' Error while updating the rule','','error');
        }
      })
    }else{
      console.log("Not Valid");
    }
    
  }

  addAML005ReceiverRule(ruleType :any, ruleData : any){
    console.log(this.userType);
    console.log(ruleType);
    console.log(ruleData);
    this.submittedAML005Count = true;
    if(this.AML005Count.valid){
      console.log("Valid");
      if(ruleData.dailyCount){
        if(Number(ruleData.dailyCount) > Number(ruleData.weeklyCount)){
          this.alertService.errorAlertWithMessage("Daily Count cannot be greater than Weekly Count");
          return;
        }
      }

      if(ruleData.weeklyCount){
        if(Number(ruleData.weeklyCount) > Number(ruleData.monthlyCount)){
          this.alertService.errorAlertWithMessage("Weekly Count cannot be greater than Monthly Count");
          return;
        }
      }
      let id = this.userType;
      if(this.userType=="AGENT"){
        id = this.selectedAgent;
      }
      console.log(id);
      var formData = {
        "id" : id,
        [ruleType] : ruleData
      }
      console.log(formData);
      this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('AML005.2 Rule updated successfully','','success');
        }else{
          Swal.fire(' Error while updating the rule','','error');
        }
      })
    }else{
      console.log("Not Valid");
    }
    
  }

  addAML006SenderRule(ruleType :any, ruleData : any){
    console.log(this.userType);
    console.log(ruleType);
    console.log(ruleData);
    this.submittedAML006Amount = true;
    if(this.AML006Amount.valid){
      console.log("Valid");
      if(ruleData.dailyAmount){
        if(Number(ruleData.dailyAmount) > Number(ruleData.weeklyAmount)){
          this.alertService.errorAlertWithMessage("Daily Amount cannot be greater than Weekly Amount");
          return;
        }
      }

      if(ruleData.weeklyAmount){
        if(Number(ruleData.weeklyAmount) > Number(ruleData.monthlyAmount)){
          this.alertService.errorAlertWithMessage("Weekly Amount cannot be greater than Monthly Amount");
          return;
        }
      }
      let id = this.userType;
      if(this.userType=="AGENT"){
        id = this.selectedAgent;
      }
      console.log(id);
      var formData = {
        "id" :id,
        [ruleType] : ruleData
      }
      console.log(formData);
      this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('AML006.1 Rule updated successfully','','success');
        }else{
          Swal.fire(' Error while updating the rule','','error');
        }
      })
    }else{
      console.log("Not Valid");
    }
    
  }

  addAML006ReceiverRule(ruleType :any, ruleData : any){
    console.log(this.userType);
    console.log(ruleType);
    console.log(ruleData);
    this.submittedAML006Count = true;
    if(this.AML006Count.valid){
      console.log("Valid");
      if(ruleData.dailyCount){
        if(Number(ruleData.dailyCount) > Number(ruleData.weeklyCount)){
          this.alertService.errorAlertWithMessage("Daily Count cannot be greater than Weekly Count");
          return;
        }
      }

      if(ruleData.weeklyCount){
        if(Number(ruleData.weeklyCount) > Number(ruleData.monthlyCount)){
          this.alertService.errorAlertWithMessage("Weekly Count cannot be greater than Monthly Count");
          return;
        }
      }
      let id = this.userType;
      if(this.userType=="AGENT"){
        id = this.selectedAgent;
      }
      console.log(id);
      var formData = {
        "id" : id,
        [ruleType] : ruleData
      }
      console.log(formData);
      this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('AML006.2 Rule updated successfully','','success');
        }else{
          Swal.fire(' Error while updating the rule','','error');
        }
      })
    }else{
      console.log("Not Valid");
    }
    
  }

  addAML007Rule(ruleType :any, ruleData : any){
    console.log(this.userType);
    console.log(ruleType);
    console.log(ruleData);
    this.submittedAML007 = true;
    if(this.AML007.valid){
      console.log("Valid");
      if(ruleData.thresholdPercentage){
        if(Number(ruleData.thresholdPercentage) > 100){
          this.alertService.errorAlertWithMessage("Percentage cannot be greater than 100");
          return;
        }
      }
      let id = this.userType;
      if(this.userType=="AGENT"){
        id = this.selectedAgent;
      }
      console.log(id);
      var formData = {
        "id" : id,
        [ruleType] : ruleData
      }
      console.log(formData);
      this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('AML007 Rule updated successfully','','success');
        }else{
          Swal.fire(' Error while updating the rule','','error');
        }
      })
    }else{
      console.log("Not Valid");
    }
    
  }

  addAML008Rule(ruleType :any, ruleData : any){
    console.log(this.userType);
    console.log(ruleType);
    console.log(ruleData);
    this.submittedAML008 = true;
    if(this.AML008.valid){
      console.log("Valid");
      let id = this.userType;
      if(this.userType=="AGENT"){
        id = this.selectedAgent;
      }
      console.log(id);
      var formData = {
        "id" : id,
        [ruleType] : ruleData
      }
      console.log(formData);
      this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('AML008 Rule updated successfully','','success');
        }else{
          Swal.fire(' Error while updating the rule','','error');
        }
      })
    }else{
      console.log("Not Valid");
    }
    
  }

  // addAML009Rule(ruleType :any, ruleData : any){
  //   console.log(this.userType);
  //   console.log(ruleType);
  //   console.log(ruleData);
  //   this.submittedAML009 = true;
  //   if(this.AML009.valid){
  //     console.log("Valid");
  //     let id = this.userType;
  //     if(this.userType=="AGENT"){
  //       id = this.selectedAgent;
  //     }
  //     console.log(id);
  //     var formData = {
  //       "id" : id,
  //       [ruleType] : ruleData
  //     }
  //     console.log(formData);
  //     this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
  //       console.log(response);
  //       if(response.response.status == 200){
  //         Swal.fire('AML009 Rule updated successfully','','success');
  //       }else{
  //         Swal.fire(' Error while updating the rule','','error');
  //       }
  //     })
  //   }else{
  //     console.log("Not Valid");
  //   }
    
  // }

  addAML010Rule(ruleType :any, ruleData : any){
    console.log(this.userType);
    console.log(ruleType);
    console.log(ruleData);
    this.submittedAML010 = true;
    if(this.AML010.valid){
      console.log("Valid");
      if(ruleData.thresholdPercentage){
        if(Number(ruleData.thresholdPercentage) > 100){
          this.alertService.errorAlertWithMessage("Percentage cannot be greater than 100");
          return;
        }
      }
      let id = this.userType;
      if(this.userType=="AGENT"){
        id = this.selectedAgent;
      }
      console.log(id);
      var formData = {
        "id" : id,
        [ruleType] : ruleData
      }
      console.log(formData);
      this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('AML010 Rule updated successfully','','success');
        }else{
          Swal.fire(' Error while updating the rule','','error');
        }
      })
    }else{
      console.log("Not Valid");
    }
    
  }

  addAML013Rule(ruleType :any, ruleData : any){
    console.log(this.userType);
    console.log(ruleType);
    console.log(ruleData);
    this.submittedAML013 = true;
    if(this.AML013.valid){
      console.log("Valid");

      if(ruleData.dailyAmount){
        if(Number(ruleData.dailyAmount) > Number(ruleData.weeklyAmount)){
          this.alertService.errorAlertWithMessage("Daily Amount cannot be greater than Weekly Amount");
          return;
        }
      }

      if(ruleData.weeklyAmount){
        if(Number(ruleData.weeklyAmount) > Number(ruleData.monthlyAmount)){
          this.alertService.errorAlertWithMessage("Weekly Amount cannot be greater than Monthly Amount");
          return;
        }
      }

      if(ruleData.dailyCount){
        if(Number(ruleData.dailyCount) > Number(ruleData.weeklyCount)){
          this.alertService.errorAlertWithMessage("Daily Count cannot be greater than Weekly Count");
          return;
        }
      }

      if(ruleData.weeklyCount){
        if(Number(ruleData.weeklyCount) > Number(ruleData.monthlyCount)){
          this.alertService.errorAlertWithMessage("Weekly Count cannot be greater than Monthly Count");
          return;
        }
      }
      let id = this.userType;
      if(this.userType=="AGENT"){
        id = this.selectedAgent;
      }
      console.log(id);
      var formData = {
        "id" : id,
        [ruleType] : ruleData
      }
      console.log(formData);
      this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('AML013 Rule updated successfully','','success');
        }else{
          Swal.fire(' Error while updating the rule','','error');
        }
      })
    }else{
      console.log("Not Valid");
    }
  }

  addAML015Rule(ruleType :any, ruleData : any){
    console.log(this.userType);
    console.log(ruleType);
    console.log(ruleData);
    this.submittedAML015 = true;
    if(this.AML015.valid){
      console.log("Valid");
      if(ruleData.countries){
        if(Number(ruleData.countries) > 250){
          this.alertService.errorAlertWithMessage("Number of Country cannot be greater than 250");
          return;
        }
      }
      if(ruleData.dailyAmount){
        if(Number(ruleData.dailyAmount) > Number(ruleData.weeklyAmount)){
          this.alertService.errorAlertWithMessage("Daily Amount cannot be greater than Weekly Amount");
          return;
        }
      }

      if(ruleData.weeklyAmount){
        if(Number(ruleData.weeklyAmount) > Number(ruleData.monthlyAmount)){
          this.alertService.errorAlertWithMessage("Weekly Amount cannot be greater than Monthly Amount");
          return;
        }
      }

      if(ruleData.dailyCount){
        if(Number(ruleData.dailyCount) > Number(ruleData.weeklyCount)){
          this.alertService.errorAlertWithMessage("Daily Count cannot be greater than Weekly Count");
          return;
        }
      }

      if(ruleData.weeklyCount){
        if(Number(ruleData.weeklyCount) > Number(ruleData.monthlyCount)){
          this.alertService.errorAlertWithMessage("Weekly Count cannot be greater than Monthly Count");
          return;
        }
      }
      let id = this.userType;
      if(this.userType=="AGENT"){
        id = this.selectedAgent;
      }
      console.log(id);
      var formData = {
        "id" : id,
        [ruleType] : ruleData
      }
      console.log(formData);
      this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('AML015 Rule updated successfully','','success');
        }else{
          Swal.fire(' Error while updating the rule','','error');
        }
      })
    }else{
      console.log("Not Valid");
    }
  }

  addAML021SenderRule(ruleType :any, ruleData : any){
    console.log(this.userType);
    console.log(ruleType);
    console.log(ruleData);
    this.submittedAML021Sender = true;
    if(this.AML021Sender.valid){
      console.log("Valid");
      if(ruleData.dailyAmount){
        if(Number(ruleData.dailyAmount) > Number(ruleData.weeklyAmount)){
          this.alertService.errorAlertWithMessage("Daily Amount cannot be greater than Weekly Amount");
          return;
        }
      }

      if(ruleData.weeklyAmount){
        if(Number(ruleData.weeklyAmount) > Number(ruleData.monthlyAmount)){
          this.alertService.errorAlertWithMessage("Weekly Amount cannot be greater than Monthly Amount");
          return;
        }
      }

      if(ruleData.dailyCount){
        if(Number(ruleData.dailyCount) > Number(ruleData.weeklyCount)){
          this.alertService.errorAlertWithMessage("Daily Count cannot be greater than Weekly Count");
          return;
        }
      }

      if(ruleData.weeklyCount){
        if(Number(ruleData.weeklyCount) > Number(ruleData.monthlyCount)){
          this.alertService.errorAlertWithMessage("Weekly Count cannot be greater than Monthly Count");
          return;
        }
      }
      let id = this.userType;
      if(this.userType=="AGENT"){
        id = this.selectedAgent;
      }
      console.log(id);
      var formData = {
        "id" : id,
        [ruleType] : ruleData
      }
      console.log(formData);
      this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('AML021.1 Rule updated successfully','','success');
        }else{
          Swal.fire(' Error while updating the rule','','error');
        }
      })
    }else{
      console.log("Not Valid");
    }
  }

  addAML021ReceiverRule(ruleType :any, ruleData : any){
    console.log(this.userType);
    console.log(ruleType);
    console.log(ruleData);
    this.submittedAML021Sender = true;
    if(this.AML021Sender.valid){
      console.log("Valid");
      if(ruleData.dailyAmount){
        if(Number(ruleData.dailyAmount) > Number(ruleData.weeklyAmount)){
          this.alertService.errorAlertWithMessage("Daily Amount cannot be greater than Weekly Amount");
          return;
        }
      }

      if(ruleData.weeklyAmount){
        if(Number(ruleData.weeklyAmount) > Number(ruleData.monthlyAmount)){
          this.alertService.errorAlertWithMessage("Weekly Amount cannot be greater than Monthly Amount");
          return;
        }
      }

      if(ruleData.dailyCount){
        if(Number(ruleData.dailyCount) > Number(ruleData.weeklyCount)){
          this.alertService.errorAlertWithMessage("Daily Count cannot be greater than Weekly Count");
          return;
        }
      }

      if(ruleData.weeklyCount){
        if(Number(ruleData.weeklyCount) > Number(ruleData.monthlyCount)){
          this.alertService.errorAlertWithMessage("Weekly Count cannot be greater than Monthly Count");
          return;
        }
      }
      let id = this.userType;
      if(this.userType=="AGENT"){
        id = this.selectedAgent;
      }
      console.log(id);
      var formData = {
        "id" : id,
        [ruleType] : ruleData
      }
      console.log(formData);
      this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('AML021.2 Rule updated successfully','','success');
        }else{
          Swal.fire(' Error while updating the rule','','error');
        }
      })
    }else{
      console.log("Not Valid");
    }
  }

  addAML023Rule(ruleType :any, ruleData : any){
    console.log(this.userType);
    console.log(ruleType);
    console.log(ruleData);
    this.submittedAML023 = true;
    if(this.AML023.valid){
      console.log("Valid");
      if(ruleData.dailyAmount){
        if(Number(ruleData.dailyAmount) > Number(ruleData.weeklyAmount)){
          this.alertService.errorAlertWithMessage("Daily Amount cannot be greater than Weekly Amount");
          return;
        }
      }

      if(ruleData.weeklyAmount){
        if(Number(ruleData.weeklyAmount) > Number(ruleData.monthlyAmount)){
          this.alertService.errorAlertWithMessage("Weekly Amount cannot be greater than Monthly Amount");
          return;
        }
      }

      if(ruleData.dailyCount){
        if(Number(ruleData.dailyCount) > Number(ruleData.weeklyCount)){
          this.alertService.errorAlertWithMessage("Daily Count cannot be greater than Weekly Count");
          return;
        }
      }

      if(ruleData.weeklyCount){
        if(Number(ruleData.weeklyCount) > Number(ruleData.monthlyCount)){
          this.alertService.errorAlertWithMessage("Weekly Count cannot be greater than Monthly Count");
          return;
        }
      }
      let id = this.userType;
      if(this.userType=="AGENT"){
        id = this.selectedAgent;
      }
      console.log(id);
      var formData = {
        "id" : id,
        [ruleType] : ruleData
      }
      console.log(formData);
      this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('AML023 Rule updated successfully','','success');
        }else{
          Swal.fire(' Error while updating the rule','','error');
        }
      })
    }else{
      console.log("Not Valid");
    }
  }

  addAML026SenderRule(ruleType :any, ruleData : any){
    console.log(this.userType);
    console.log(ruleType);
    console.log(ruleData);
    this.submittedAML026Sender = true;
    if(this.AML026Sender.valid){
      console.log("Valid");
      if(ruleData.dailyAmount){
        if(Number(ruleData.dailyAmount) > Number(ruleData.weeklyAmount)){
          this.alertService.errorAlertWithMessage("Daily Amount cannot be greater than Weekly Amount");
          return;
        }
      }

      if(ruleData.weeklyAmount){
        if(Number(ruleData.weeklyAmount) > Number(ruleData.monthlyAmount)){
          this.alertService.errorAlertWithMessage("Weekly Amount cannot be greater than Monthly Amount");
          return;
        }
      }

      if(ruleData.dailyCount){
        if(Number(ruleData.dailyCount) > Number(ruleData.weeklyCount)){
          this.alertService.errorAlertWithMessage("Daily Count cannot be greater than Weekly Count");
          return;
        }
      }

      if(ruleData.weeklyCount){
        if(Number(ruleData.weeklyCount) > Number(ruleData.monthlyCount)){
          this.alertService.errorAlertWithMessage("Weekly Count cannot be greater than Monthly Count");
          return;
        }
      }
      let id = this.userType;
      if(this.userType=="AGENT"){
        id = this.selectedAgent;
      }
      console.log(id);
      var formData = {
        "id" : id,
        [ruleType] : ruleData
      }
      console.log(formData);
      this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('AML026.1 Rule updated successfully','','success');
        }else{
          Swal.fire(' Error while updating the rule','','error');
        }
      })
    }else{
      console.log("Not Valid");
    }
  }

  addAML026ReceiverRule(ruleType :any, ruleData : any){
    console.log(this.userType);
    console.log(ruleType);
    console.log(ruleData);
    this.submittedAML026Receiver = true;
    if(this.AML026Receiver.valid){
      console.log("Valid");
      if(ruleData.dailyAmount){
        if(Number(ruleData.dailyAmount) > Number(ruleData.weeklyAmount)){
          this.alertService.errorAlertWithMessage("Daily Amount cannot be greater than Weekly Amount");
          return;
        }
      }

      if(ruleData.weeklyAmount){
        if(Number(ruleData.weeklyAmount) > Number(ruleData.monthlyAmount)){
          this.alertService.errorAlertWithMessage("Weekly Amount cannot be greater than Monthly Amount");
          return;
        }
      }

      if(ruleData.dailyCount){
        if(Number(ruleData.dailyCount) > Number(ruleData.weeklyCount)){
          this.alertService.errorAlertWithMessage("Daily Count cannot be greater than Weekly Count");
          return;
        }
      }

      if(ruleData.weeklyCount){
        if(Number(ruleData.weeklyCount) > Number(ruleData.monthlyCount)){
          this.alertService.errorAlertWithMessage("Weekly Count cannot be greater than Monthly Count");
          return;
        }
      }
      let id = this.userType;
      if(this.userType=="AGENT"){
        id = this.selectedAgent;
      }
      console.log(id);
      var formData = {
        "id" : id,
        [ruleType] : ruleData
      }
      console.log(formData);
      this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('AML026.2 Rule updated successfully','','success');
        }else{
          Swal.fire(' Error while updating the rule','','error');
        }
      })
    }else{
      console.log("Not Valid");
    }
  }

  addAML027Rule(ruleType :any, ruleData : any){
    console.log(this.userType);
    console.log(ruleType);
    console.log(ruleData);
    this.submittedAML027 = true;
    if(this.AML027.valid){
      console.log("Valid");
      if(ruleData.dailyAmount){
        if(Number(ruleData.dailyAmount) > Number(ruleData.weeklyAmount)){
          this.alertService.errorAlertWithMessage("Daily Amount cannot be greater than Weekly Amount");
          return;
        }
      }

      if(ruleData.weeklyAmount){
        if(Number(ruleData.weeklyAmount) > Number(ruleData.monthlyAmount)){
          this.alertService.errorAlertWithMessage("Weekly Amount cannot be greater than Monthly Amount");
          return;
        }
      }

      if(ruleData.dailyCount){
        if(Number(ruleData.dailyCount) > Number(ruleData.weeklyCount)){
          this.alertService.errorAlertWithMessage("Daily Count cannot be greater than Weekly Count");
          return;
        }
      }

      if(ruleData.weeklyCount){
        if(Number(ruleData.weeklyCount) > Number(ruleData.monthlyCount)){
          this.alertService.errorAlertWithMessage("Weekly Count cannot be greater than Monthly Count");
          return;
        }
      }
      let id = this.userType;
      if(this.userType=="AGENT"){
        id = this.selectedAgent;
      }
      console.log(id);
      var formData = {
        "id" : id,
        [ruleType] : ruleData
      }
      console.log(formData);
      this.transactionService.updateAMLRule(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('AML027 Rule updated successfully','','success');
        }else{
          Swal.fire(' Error while updating the rule','','error');
        }
      })
    }else{
      console.log("Not Valid");
    }
  }
  
  async updateAml18(data:any){
    console.log(data);
    //Input Count Field Validation
    if(data.dailyCount == ""){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter Daily Count");
      return false;
    }
    if(data.weeklyCount == ""){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter Weekly Count");
      return false;
    }
    if(data.monthlyCount == ""){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter Monthly Count");
      return false;
    }

    //Input Count Field Comparision Validation
    if(Number(data.dailyCount) > Number(data.weeklyCount)){
      this.alertService.toastWarringMessageAlertWithMessage("Daily Count cannot be greater than Weekly Count");
      return false;
    }
    if(Number(data.weeklyCount) > Number(data.monthlyCount)){
      this.alertService.toastWarringMessageAlertWithMessage("Weekly Count cannot be greater than Monthly Count");
      return false;
    }
    

    //Input Amount Field Validation
    if(data.dailyAmount == ""){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter Daily Amount");
      return false;
    }
    if(data.weeklyAmount == ""){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter Weekly Amount");
      return false;
    }
    if(data.monthlyAmount == ""){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter Monthly Amount");
      return false;
    }

    //Input Amount Field Comparision Validation
    if(Number(data.dailyAmount) > Number(data.weeklyAmount)){
      this.alertService.toastWarringMessageAlertWithMessage("Daily Amount cannot be greater than Weekly Amount");
      return false;
    }
    if(Number(data.weeklyAmount) > Number(data.monthlyAmount)){
      this.alertService.toastWarringMessageAlertWithMessage("Weekly Amount cannot be greater than Monthly Amount");
      return false;
    }

    //API call
    let amlTableItems = [];
    amlTableItems.push(data);
    let dataList = {
      "amlTableItems" : amlTableItems
    }

    let id = this.userType;
    if(this.userType=="AGENT"){
      id = this.selectedAgent;
    }
    console.log(id);
    let formdata = {
      "id" : id,
      "aml018" : dataList,
    }
    let res = await this.transactionService.updateAMLRule(formdata).toPromise();
    if(res.response.status == 200){
      Swal.fire('AML018 Rule updated successfully','','success');
      // this.labelListAml18 = this.labelListAml18.filter(item =>{
      //   return item.label!=data.label
      // })

      // this.aml18Dropdown = this.aml18Dropdown.filter(item =>{
      //   return item!=data.label
      // })
      this.transactionService.getAMLRule(id).subscribe((response:any)=>{
        console.log(response.response.data);
        if(response.response.status == 200){
          this.setAmlValues("update",response.response.data);
          this.aml18Dropdown = [];

        }
      })
      return true;
    }else{
      Swal.fire('Error while updating the Rule','','error');
      return false;
    }
  }

  async updateAml19(data:any){
    console.log(data);
    //Input Count Field Validation
    if(data.dailyCount == ""){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter Daily Count");
      return false;
    }
    if(data.weeklyCount == ""){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter Weekly Count");
      return false;
    }
    if(data.monthlyCount == ""){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter Monthly Count");
      return false;
    }

    //Input Count Field Comparision Validation
    if(Number(data.dailyCount) > Number(data.weeklyCount)){
      this.alertService.toastWarringMessageAlertWithMessage("Daily Count cannot be greater than Weekly Count");
      return false;
    }
    if(Number(data.weeklyCount) > Number(data.monthlyCount)){
      this.alertService.toastWarringMessageAlertWithMessage("Weekly Count cannot be greater than Monthly Count");
      return false;
    }
    

    //Input Amount Field Validation
    if(data.dailyAmount == ""){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter Daily Amount");
      return false;
    }
    if(data.weeklyAmount == ""){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter Weekly Amount");
      return false;
    }
    if(data.monthlyAmount == ""){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter Monthly Amount");
      return false;
    }

    //Input Amount Field Comparision Validation
    if(Number(data.dailyAmount) > Number(data.weeklyAmount)){
      this.alertService.toastWarringMessageAlertWithMessage("Daily Amount cannot be greater than Weekly Amount");
      return false;
    }
    if(Number(data.weeklyAmount) > Number(data.monthlyAmount)){
      this.alertService.toastWarringMessageAlertWithMessage("Weekly Amount cannot be greater than Monthly Amount");
      return false;
    }

    //API call
    let amlTableItems = [];
    amlTableItems.push(data);
    let dataList = {
      "amlTableItems" : amlTableItems
    }
    let id = this.userType;
    if(this.userType=="AGENT"){
      id = this.selectedAgent;
    }
    console.log(id);
    let formdata = {
      "id" : id,
      "aml019" : dataList,
    }
    let res = await this.transactionService.updateAMLRule(formdata).toPromise();
    if(res.response.status == 200){
      Swal.fire('AML019 Rule updated successfully','','success');
      // this.labelListAml19 = this.labelListAml19.filter(item =>{
      //   return item.label!=data.label
      // })

      // this.aml19Dropdown = this.aml19Dropdown.filter(item =>{
      //   return item!=data.label
      // })
      this.transactionService.getAMLRule(id).subscribe((response:any)=>{
        console.log(response.response.data);
        if(response.response.status == 200){
          this.setAmlValues("update",response.response.data);
          this.aml19Dropdown = [];
        }
      })
      return true;
    }else{
      Swal.fire('Error while updating the Rule','','error');
      return false;
    }
  }

  deleteAmlRule(rule:any,label:any){
    console.log(this.userType);
    console.log(rule);
    console.log(label);
    let id = this.userType;
    if(this.userType=="AGENT"){
      id = this.selectedAgent;
    }
    let labelData = [];
    labelData.push(
      {
        label : label
      });
    let amlData = {
      amlTableItems : labelData
    }
    console.log(this.userType);
    let formData = {
      "id" : id,
      [rule] : amlData
    }
    console.log(formData);
    this.transactionService.deleteAmlRule(formData).subscribe((response:any)=>{
      console.log(response);
      if(response.response.status == 200){
        Swal.fire('Label deleted successfully','','success');
        this.transactionService.getAMLRule(this.userType).subscribe((res:any)=>{
          console.log(res.response.data);
          if(res.response.status == 200){
            this.setAmlValues("delete",res.response.data);
            if(rule == "aml018"){
              this.aml18Dropdown = [];
            }else if(rule == "aml019"){
              this.aml19Dropdown = [];
            }
          }
        })
      }else{
        Swal.fire('Error while deleting the rule','','error');
      }
    })
    
  }
  
  removeLabel(ruleType:any,event: any){
    console.log(this.aml18Dropdown);
    console.log("Remove Event");
    console.log(ruleType);
    console.log(event.value);
    if(ruleType == "AML18"){
      for(let i:number= 0 ;i<this.aml18Data.length ; i++){
        if(this.aml18Data[i].label == event.value){
          this.aml18Data.splice(i,1);
          this.gridApi18.setRowData(this.aml18Data);
          console.log(this.aml18Data);
        }
      }
    }else if(ruleType == "AML19"){
      for(let i:number= 0 ;i<this.aml19Data.length ; i++){
        if(this.aml19Data[i].label == event.value){
          this.aml19Data.splice(i,1);
          this.gridApi19.setRowData(this.aml19Data);
          console.log(this.aml19Data);
        }
      }
    }    
  }

  async addNewLabel(ruleType : any,selectedLabel: Event){
    console.log(this.aml18Dropdown);
    console.log("Add Event");
    console.log(ruleType);
    console.log(selectedLabel);
      if(ruleType == "AML18"){
        console.log(this.aml18Data);
        const newRow = {"label":selectedLabel,"enable":false,"notify":false,"block":false,"dailyCount":1,"weeklyCount":10,"monthlyCount":100,"dailyAmount":100,"weeklyAmount":1000,"monthlyAmount":10000,"editFlag":true,"reviewFlag":false};
        this.aml18Data = [...this.aml18Data, newRow];
        this.gridApi18.setRowData(this.aml18Data);
        console.log(this.aml18Data);
            //API call
        let amlTableItems = [];
        amlTableItems.push(newRow);
        let dataList = {
          "amlTableItems" : amlTableItems
        }

        let id = this.userType;
        if(this.userType=="AGENT"){
          id = this.selectedAgent;
        }
        console.log(id);
        let formdata = {
          "id" : id,
          "aml018" : dataList,
        }
        let res = await this.transactionService.updateAMLRule(formdata).toPromise();
        if(res.response.status == 200){
          Swal.fire('AML018 Rule updated successfully','','success');
          this.transactionService.getAMLRule(id).subscribe((response:any)=>{
            console.log(response.response.data);
            if(response.response.status == 200){
              this.setAmlValues("update",response.response.data);
              this.aml18Dropdown = [];

            }
          })
          return; 
        }
      }else if(ruleType == "AML19"){
        console.log(this.aml19Data);
        const newRow = {"label":selectedLabel,"enable":false,"notify":false,"block":false,"dailyCount":1,"weeklyCount":10,"monthlyCount":100,"dailyAmount":100,"weeklyAmount":1000,"monthlyAmount":10000,"editFlag":true,"reviewFlag":false};
        this.aml19Data = [...this.aml19Data, newRow];
        this.gridApi18.setRowData(this.aml19Data);
        console.log(this.aml19Data);
        // API call
        let amlTableItems = [];
        amlTableItems.push(newRow);
        let dataList = {
          "amlTableItems" : amlTableItems
        }
        let id = this.userType;
        if(this.userType=="AGENT"){
          id = this.selectedAgent;
        }
        console.log(id);
        let formdata = {
          "id" : id,
          "aml019" : dataList,
        }
        let res = await this.transactionService.updateAMLRule(formdata).toPromise();
        if(res.response.status == 200){
          Swal.fire('AML019 Rule updated successfully','','success');

          this.transactionService.getAMLRule(id).subscribe((response:any)=>{
            console.log(response.response.data);
            if(response.response.status == 200){
              this.setAmlValues("update",response.response.data);
              this.aml19Dropdown = [];
            }
          })
          return;
          }
      }
  }

  emailConfigModal(userType : any){
    console.log(userType);
    this.transactionService.getEmailConfig(userType).subscribe((response:any)=>{
      console.log(response);
      if(userType == "AGENT"){
        this.emailListAgent = response.response.data;
      }else if(userType == "CUSTOMER"){
        this.emailListCustomer = response.response.data;
      }
    });
    this.emailConfigurationModal.open();
  }

  addEmail(userType : any){
    console.log(userType);
    console.log(this.addEmailForm.value.emailInput)
    this.submitted =true;
    if(this.addEmailForm.valid){
      console.log("Valid");
      let formData;
      if(userType == "DEFAULT_CUSTOMER"){
        formData = {
            "userType": "CUSTOMER",
            "email": this.addEmailForm.value.emailInput,
        }
        this.gridApiEmail.setRowData(this.emailListCustomer);
      }else if(userType == "AGENT"){
        formData = {
          "userType": "AGENT",
          "email": this.addEmailForm.value.emailInput,
      }
        this.gridApiEmail.setRowData(this.emailListAgent);
      }
      this.transactionService.AddEmailConfig(formData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          this.submitted =false;
          this.addEmailForm.controls.emailInput.setValue("");
          if(userType == "DEFAULT_CUSTOMER"){
            userType = "CUSTOMER";
          }else if(userType == "AGENT"){
            userType = "AGENT";
          }
          this.transactionService.getEmailConfig(userType).subscribe((response:any)=>{
            console.log(response);
            if(userType == "AGENT"){
              this.emailListAgent = response.response.data;
            }else if(userType == "CUSTOMER"){
              this.emailListCustomer = response.response.data;
            }
          });
          Swal.fire('Email ID added successfully','','success');
        }else{
          Swal.fire('Error while saving the Email ID','','error');
        }
      });
      
    }else{
      console.log("Not Valid");
    }
  }

  deleteEmail(userType:any,id: any){
    console.log(id);
    console.log(userType);
    this.transactionService.deleteEmailConfig(id).subscribe((response:any)=>{
      console.log(response);
      if(response.response.status == 200){
        Swal.fire('Email ID deleted successfully','','success');
        this.transactionService.getEmailConfig(userType).subscribe((response:any)=>{
          console.log(response);
          if(userType == "AGENT"){
            this.emailListAgent = response.response.data;
          }else if(userType == "CUSTOMER"){
            this.emailListCustomer = response.response.data;
          }
        });
      }
    })
    
  }
}


